import BaseService from "../../../../../service/BaseService";
import SubmitOutput from "./dto/SubmitOutput";
import Po2BulkMailerEntity from "../../../ustore/v002/utils/Po2BulkMailerEntity";

class OmsModuleService extends BaseService {

  static NAME = 'OmsModuleService';

  static buildSubmitOutputDto(name, queueName, template, scheduledStartDateTime, mailTo, mailToDisplayText,
                              testMailReceiver, testMailNumOfSendings, query, action) {

    let po2BulkMailerEntity = new Po2BulkMailerEntity(name, queueName, template, scheduledStartDateTime, mailTo,
      mailToDisplayText, testMailReceiver, testMailNumOfSendings, '', query)

    return new SubmitOutput(name, queueName, po2BulkMailerEntity, scheduledStartDateTime, action, '');
  }
}

export default OmsModuleService;
